import { FC } from "react";

import { Grid } from "@mui/material";
import ChildCard from "@shared-layouts/ChildCard";

import LastUpdated from "@shared-containers/LastUpdated";
import { CustomSmallCardWrapper } from "../../HomeDashboard/style";
import ClosedOpenCheck from "./ClosedOpenCheck";
import { LastUpdatedWrapper } from "./style";

interface CheckSummaryType {
  checkDashboardData: CheckDashboardSummaryDataType;
  isLoading: boolean;
}

const CheckSummary: FC<CheckSummaryType> = ({
  checkDashboardData,
  isLoading,
}) => {
  return (
    <CustomSmallCardWrapper>
      <ChildCard title="Check Summary">
        <Grid style={{ marginTop: 8 }} direction="row" container>
          <ClosedOpenCheck
            title="Open Checks"
            value={checkDashboardData?.open}
            isLoading={isLoading}
            isInteger
          />
          <ClosedOpenCheck
            title="Closed Checks"
            value={checkDashboardData?.closed}
            isLoading={isLoading}
            isInteger
          />
          <LastUpdatedWrapper>
            <LastUpdated
              loading={isLoading}
              lastUpdatedTime={checkDashboardData?.last_updated}
            />
          </LastUpdatedWrapper>
        </Grid>
      </ChildCard>
    </CustomSmallCardWrapper>
  );
};

export default CheckSummary;
